export class Usuario {
  id?: number;

  // ID da empresa (tenant) - armazenamos como string (UUID)
  empresaId?: string;

  username!: string;
  password!: string;

  roles?: string[];
  dataCadastro: string = '';
  dataUltimaModificacao: string | null = null;

  // Situação do usuário
  ativo?: boolean;

}
